// Dependencies
import React from "react";
import { css } from "emotion";
import logoRagrom from "../assets/logo_ragrom_white.svg";
import LogoutComponent from "./LogoutComponent";

const Header = () => {
  return (
    <div
      className={css`
        background-color: #455a64;
        padding: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      `}
    >
      <div className={css``}>
        <img
          alt="ragrom"
          src={logoRagrom}
          className={css`
            height: 25px;
          `}
        />
      </div>
      <LogoutComponent />
    </div>
  );
};

export default Header;
